<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item active>People</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
          <div class="card-header">
            <ul class="card-header-tabs nav nav-tabs">
                <li class="nav-item">
                    <a @click="currentTabComponent='TheTTIPeopleList'; resetFilter();" :class="currentTabComponent === 'TheTTIPeopleList' ? 'active' : null" class="nav-link"
                        data-toggle="tab"
                        href="#">TTI</a>
                </li>
                <li class="nav-item">
                    <a @click="currentTabComponent='TheNonTTIPeopleList'; resetFilter();" :class="currentTabComponent === 'TheNonTTIPeopleList' ? 'active' : null" class="nav-link"
                        data-toggle="tab"
                        href="#">Non-TTI</a>
                </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="card">
                <div class="bg-dark card-header text-white">{{ currentTabComponent === 'TheNonTTIPeopleList' ? 'Non-TTI' : 'TTI' }} People</div>
                <div class="card-body">
                    <div class="form-row">
                      <div class="col-lg-6 pb-2">
                        <fieldset class="border p-3 mr-2" style="height: 100%;">
                            <template v-if="currentTabComponent === 'TheTTIPeopleList'">
                                <legend class="w-auto h5">Employment Type</legend>
                                <b-form-group>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <b-form-radio @change.native="onFilterSubmit()" v-model="filterOptions.payIndicators" :value="null">All Employees </b-form-radio>
                                            <b-form-radio @change.native="onFilterSubmit()" v-model="filterOptions.payIndicators" :value="monthlyFullAndPartTimePayIndicators">Monthly Full-time/Part-time Faculty and Staff</b-form-radio>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <b-form-radio @change.native="onFilterSubmit()" v-model="filterOptions.payIndicators" :value="monthlyGraduatePayIndicators">Monthly Graduate Students</b-form-radio>
                                            <b-form-radio @change.native="onFilterSubmit()" v-model="filterOptions.payIndicators" :value="biWeeklyPayIndicators">Bi-Weekly Full-time/Part-time Staff and Student Workers</b-form-radio>
                                        </div>
                                    </div>                           
                                </b-form-group>
                            </template>
                            <template v-if="currentTabComponent === 'TheNonTTIPeopleList'">
                                <legend class="w-auto h5">Designation</legend>
                                <b-form-group>
                                    <b-form-radio @change.native="updateNonTTIDesignation(); onFilterSubmit()" v-model="filterOptions.employeeTTIAffiliation" :value="null">All</b-form-radio>
                                    <b-form-radio @change.native="updateNonTTIDesignation(); onFilterSubmit()" v-model="filterOptions.employeeTTIAffiliation" v-for="affiliation in employeeTTIAffiliations" :key="affiliation.item" :value="affiliation.value">{{affiliation.item}} <i v-if="affiliation.info !== null" v-b-tooltip.hover :title="affiliation.info" class="fas fa-info-circle"></i></b-form-radio>                   
                                </b-form-group>
                            </template>
                        </fieldset>
                      </div>
                      <div class="col-lg-6 pb-2">
                        <fieldset class="border p-3 mr-2" style="height: 100%;">
                          <legend class="w-auto h5">Employment Status</legend>
                          <AppCheckBox
                                  v-model="showActiveEmploymentStatuses"
                                  @change="updateEmploymentStatuses()">
                            Active <i v-if="currentTabComponent === 'TheTTIPeopleList'" v-b-tooltip.hover :title="activeEmploymentStatuses.map((status) => { return status.name; }).join(', ')" class="fas fa-info-circle"></i>
                          </AppCheckBox>
                          <AppCheckBox
                                  v-model="showInactiveEmploymentStatuses"
                                  @change="updateEmploymentStatuses()">
                            Inactive <i v-if="currentTabComponent === 'TheTTIPeopleList'" v-b-tooltip.hover :title="inactiveEmploymentStatuses.map((status) => { return status.name; }).join(', ')" class="fas fa-info-circle"></i>
                          </AppCheckBox>
                        </fieldset>
                      </div>
                    </div>
                    <!-- The collapsable filter options -->
                    <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                        <template v-slot:header>Filter</template>
                        <template v-slot:body>
                            <div class="form-row">
                                <div class="col-md-3 col-sm-6 form-group">
                                    <label>Name</label>
                                    <input
                                            class="form-control"
                                            placeholder="Name"
                                            v-model="filterOptions.name"
                                    />
                                </div>
                                <div class="col-md-2 col-sm-6 form-group">
                                    <label>UIN</label>
                                    <input
                                            class="form-control"
                                            placeholder="UIN"
                                            v-model="filterOptions.uin"
                                    />
                                </div>
                                <div v-if="currentTabComponent === 'TheTTIPeopleList'" class="col-md-3 col-sm-6 form-group">
                                    <label>Supervisor Name</label>
                                    <input
                                            class="form-control"
                                            placeholder="Supervisor Name"
                                            v-model="filterOptions.supervisorName"
                                    />
                                </div>
                                <div class="col-md-2 col-sm-6">
                                    <label v-if="currentTabComponent === 'TheTTIPeopleList'">Organization</label>
                                    <label v-else>TTI Organization</label>
                                    <select class="form-control" v-model="filterOptions.organizationId">
                                        <option :value="null">All</option>
                                        <option :key="org.id" :value="org.id" v-for="org in organizations"><span>{{org.name}}</option>
                                    </select>
                                </div>
                                <div v-if="currentTabComponent !== 'TheTTIPeopleList' && ((filterOptions.employeeTTIAffiliation & employeeTTIAffiliation.ResearchAffiliate) === employeeTTIAffiliation.ResearchAffiliate || filterOptions.employeeTTIAffiliation === null)" class="col-md-2 col-sm-6">
                                    <label>External Organization</label>
                                    <select class="form-control" v-model="filterOptions.externalOrganizationCode">
                                        <option :value="null">All</option>
                                        <option :key="org" :value="org" v-for="org in externalOrganizations"><span>{{org}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 col-sm-6">
                                    <label>TTI Account</label>
                                    <select class="form-control" v-model="filterOptions.adStatus">
                                        <option :value="null">All</option>
                                        <option :key="status.item" :value="status.value" v-for="status in adStatuses">{{status.item}}</option>
                                    </select>
                                </div>
                            </div>
                            <br>
                            <div class="form-row">
                              <div class="col-lg-12 pb-2">
                                <fieldset class="border p-3 mr-2">
                                  <legend class="w-auto h6">Missing Options</legend>
                                  <template v-if="currentTabComponent === 'TheTTIPeopleList'">
                                    <AppCheckBox v-model="filterOptions.onlyShowMissingAddress">
                                        Address
                                    </AppCheckBox>
                                    <AppCheckBox v-model="incompleteRecordFlags" @change="updateIncompleteRecordFlags()">
                                        Incomplete Record <i v-b-tooltip.hover title="UIN, FTE, Pay Indicator, or Org Code is missing from employee's record" class="fas fa-info-circle"></i>
                                    </AppCheckBox>
                                  </template>
                                  <template v-else>
                                    <AppCheckBox v-if="(filterOptions.employeeTTIAffiliation & employeeTTIAffiliation.ResearchAffiliate) === employeeTTIAffiliation.ResearchAffiliate" v-model="filterOptions.onlyShowMissingAddress">
                                        Address
                                    </AppCheckBox>
                                    <AppCheckBox v-model="incompleteRecordFlags" v-if="(filterOptions.employeeTTIAffiliation & employeeTTIAffiliation.ResearchAffiliate) === employeeTTIAffiliation.ResearchAffiliate" @change="updateIncompleteRecordFlags()">
                                        Incomplete Record <i v-b-tooltip.hover title="UIN, Email, External Supervisor, or TTI Org Code is missing from employee's record" class="fas fa-info-circle"></i>
                                    </AppCheckBox>
                                    <AppCheckBox v-model="incompleteRecordFlags" v-else @change="updateIncompleteRecordFlags()">
                                        Incomplete Record <i v-b-tooltip.hover title="UIN, Email, or External Supervisor is missing from employee's record" class="fas fa-info-circle"></i>
                                    </AppCheckBox>
                                  </template>
                                </fieldset>
                              </div>
                            </div>
                        </template>
                        <template v-slot:footer>
                            <button class="btn btn-primary" type="submit">Apply</button>
                        </template>
                    </AppFormCardCollapsable>

                    <div class="row">
                        <div class="col d-print-none dropdown mb-3 text-right">
                            <button :disabled="isPerformingAction" aria-expanded="false" aria-haspopup="true"
                                    class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" style="width: 100px"
                                    type="button">
                                <span>Actions</span>
                            </button>
                            <div class="dropdown-menu">
                                <a @click.prevent="downloadCsvExport()" class="btn btn-outline-light dropdown-item text-left"
                                  href="javascript:void(0)" title="Export account list to a CSV">
                                    <i class="fa fa-file-excel"></i>Download .csv
                                </a>
                            </div>
                        </div>
                    </div>

                    <BTable
                            :busy="isLoading"
                            :fields="tableFields"
                            :items="people"
                            :responsive="true"
                            primary-key="id"
                            show-empty
                            striped
                            table-class="table-align-middle">
                        
                        <template v-slot:head(payIndicator)="column">
                            <b-tooltip target="payIndicatorInfo">
                              <div class="text-left">
                                <template v-for="payIndicator in payIndicators">
                                    <span  :key="payIndicator.code">
                                        {{ payIndicator.code }}: {{ payIndicator.description }}
                                    </span><br :key="payIndicator.code">
                                </template>
                              </div>
                            </b-tooltip>
                            {{ column.label }} <i id="payIndicatorInfo" class="fas fa-info-circle"></i>
                        </template>

                        <template v-slot:cell(id)="row">
                            <router-link :to="{name:'PersonDetails',params:{id:row.item.id, personName:row.item.name, personUIN:row.item.uin}}"
                                        class="btn btn-sm btn-warning d-print-none"
                                        data-toggle="tooltip"
                                        title="Edit person details">
                                <i class="fa fa-pencil-alt"></i>Edit
                            </router-link>
                        </template>

                        <template v-slot:cell(fte)="row">
                            {{ row.item.fte }}%
                        </template>

                        <template v-slot:cell(inAD)="row">
                            {{ row.item.inAD ? "Active" : "No Account" }}{{ row.item.expiredInAD ? ", Expired" : "" }}
                        </template>

                        <!-- Footer Pagination -->
                        <template v-slot:custom-foot>
                            <b-tr>
                                <b-td :colspan="tableFields.length">
                                    <AppTablePagination
                                            :page.sync="filterOptions.page"
                                            :pageSize.sync="filterOptions.pageSize"
                                            :totalCount.sync="totalPeople"
                                            v-on:update:page="loadData()"
                                            v-on:update:pageSize="onFilterSubmit()"
                                    ></AppTablePagination>
                                </b-td>
                            </b-tr>
                        </template>

                    </BTable>

                </div>
            </div>
          </div>
      </div>

    </div>
</template>

<script>
    import {Configuration} from "@/Configuration";
    import PersonService from "@/services/PersonService";
    import OrganizationService from "@/services/OrganizationService";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {ADStatusDescriptions, EmployeeTTIAffiliationDescriptions, EmployeeTTIAffiliation, EmployeeClassification, IncompleteRecordFlag} from "@/services/models/Person";

    export default {
        components: {
            AppFormCardCollapsable,
            AppCheckBox,
            AppTablePagination,
        },
        data() {
            return {
                isPerformingAction: false,
                currentTabComponent: 'TheTTIPeopleList',
                people: [],
                totalPeople: 0,
                showActiveEmploymentStatuses: true,
                showInactiveEmploymentStatuses: false,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    name: null,
                    uin: null,
                    organizationCode: null,
                    organizationId: null,
                    supervisorName: null,
                    onlyShowActive: false,
                    onlyShowMissingAddress: false,
                    onlyShowTTI: false,
                    isNonTTIEmployee: false,
                    employeeType: null,
                    employmentStatus: null,
                    employeeTypes: null,
                    employmentStatuses: null,
                    payIndicators: null,
                    adStatus: null,
                    employeeClassification: EmployeeClassification.TTI,
                    employeeTTIAffiliation: null,
                    incompleteRecordFlags: null,
                    externalOrganizationCode: null
                },
                isLoading: false,
                adStatuses: [],
                employeeTTIAffiliations: [],
                payIndicators: [],
                employmentStatuses: [],
                organizations: [],
                externalOrganizations: [],
                incompleteRecordFlags: false
            }
        },
        computed: {
            tableFields() {
                return this.currentTabComponent === "TheTTIPeopleList" 
                    ?   [
                            {
                                key: 'id',
                                label: '',
                                thStyle: 'width:100px'
                            },
                            {
                                key: 'name',
                                label: 'Name'
                            },
                            {
                                key: 'uin',
                                label: 'UIN'
                            },
                            {
                                key: 'employeeType',
                                label: 'Employee Type'
                            },
                            {
                                key: 'supervisorName',
                                label: 'Supervisor'
                            },
                            {
                                key: 'organizationCode',
                                label: 'Employee Organization',
                                thStyle: 'width:90px'
                            },
                            {
                                key: 'employmentStatus',
                                label: 'Employment Status'
                            },
                            {
                                key: 'fte',
                                label: '% FTE'
                            },
                            {
                                key: 'payIndicator',
                                label: 'Pay Indicator'
                            },
                            {
                                key: 'payType',
                                label: 'Pay Type'
                            },
                            {
                                key: 'payFrequency',
                                label: 'Pay Frequency'
                            },
                            {
                                key: 'payClassification',
                                label: 'Budgeted/Waged'
                            },
                            {
                                key: 'inAD',
                                label: 'TTI Login'
                            }
                        ] 
                    : this.filterOptions.employeeTTIAffiliation !== null
                        ? this.filterOptions.employeeTTIAffiliation === EmployeeTTIAffiliation.ResearchAffiliate
                            ?
                                [
                                    {
                                        key: 'id',
                                        label: '',
                                        thStyle: 'width:100px'
                                    },
                                    {
                                        key: 'name',
                                        label: 'Name'
                                    },
                                    {
                                        key: 'uin',
                                        label: 'UIN'
                                    },
                                    {
                                        key: 'emailAddress',
                                        label: 'Email'
                                    },
                                    {
                                        key: 'employeeType',
                                        label: 'Employee Type'
                                    },
                                    {
                                        key: 'supervisorName',
                                        label: 'External Supervisor'
                                    },
                                    {
                                        key: 'supervisoryOrganization',
                                        label: 'Supervisory Organization'
                                    },
                                    {
                                        key: 'externalOrganization',
                                        label: 'External Organization'
                                    },
                                    {
                                        key: 'organizationCode',
                                        label: 'TTI Organization',
                                        thStyle: 'width:90px'
                                    },
                                    {
                                        key: 'employmentStatus',
                                        label: 'External Employment Status'
                                    },
                                    {
                                        key: 'inAD',
                                        label: 'TTI Login'
                                    }
                                ]
                            :
                                [
                                    {
                                        key: 'id',
                                        label: '',
                                        thStyle: 'width:100px'
                                    },
                                    {
                                        key: 'name',
                                        label: 'Name'
                                    },
                                    {
                                        key: 'uin',
                                        label: 'UIN'
                                    },
                                    {
                                        key: 'emailAddress',
                                        label: 'Email'
                                    },
                                    {
                                        key: 'employeeType',
                                        label: 'Employee Type'
                                    },
                                    {
                                        key: 'supervisorName',
                                        label: 'External Supervisor'
                                    },
                                    {
                                        key: 'supervisoryOrganization',
                                        label: 'Supervisory Organization'
                                    },
                                    {
                                        key: 'externalOrganization',
                                        label: 'External Organization'
                                    },
                                    {
                                        key: 'employmentStatus',
                                        label: 'External Employment Status'
                                    },
                                    {
                                        key: 'inAD',
                                        label: 'TTI Login'
                                    }
                                ]
                        :
                            [
                                {
                                    key: 'id',
                                    label: '',
                                    thStyle: 'width:100px'
                                },
                                {
                                    key: 'name',
                                    label: 'Name'
                                },
                                {
                                    key: 'uin',
                                    label: 'UIN'
                                },
                                {
                                    key: 'emailAddress',
                                    label: 'Email'
                                },
                                {
                                    key: 'employeeType',
                                    label: 'Employee Type'
                                },
                                {
                                    key: 'employeeTTIAffiliation',
                                    label: 'Non-TTI Designation'
                                },
                                {
                                    key: 'supervisorName',
                                    label: 'External Supervisor'
                                },
                                {
                                    key: 'supervisoryOrganization',
                                    label: 'Supervisory Organization'
                                },
                                {
                                    key: 'externalOrganization',
                                    label: 'External Organization'
                                },
                                {
                                    key: 'organizationCode',
                                    label: 'TTI Organization',
                                    thStyle: 'width:90px'
                                },
                                {
                                    key: 'employmentStatus',
                                    label: 'External Employment Status'
                                },
                                {
                                    key: 'inAD',
                                    label: 'TTI Login'
                                }
                            ]

            },

            activeEmploymentStatuses() {
                return this.employmentStatuses.filter((status) => { return status.indicatesIsActive; });
            },
            
            inactiveEmploymentStatuses() {
                return this.employmentStatuses.filter((status) => { return !status.indicatesIsActive; });
            },

            monthlyFullAndPartTimePayIndicators() {
                return this.payIndicators.filter((indicator) => { return (indicator.description.toLowerCase().includes('full-time') || indicator.description.toLowerCase().includes('part-time')) && indicator.payFrequency.toLowerCase() === 'monthly'; }).map((indicator) => { return indicator.code; });
            },

            monthlyGraduatePayIndicators() {
                return this.payIndicators.filter((indicator) => { return indicator.description.toLowerCase().includes('graduate') && indicator.payFrequency.toLowerCase() === 'monthly'; }).map((indicator) => { return indicator.code; });
            },

            biWeeklyPayIndicators() {
                return this.payIndicators.filter((indicator) => { return indicator.payFrequency.toLowerCase() === 'bi-weekly'; }).map((indicator) => { return indicator.code; });
            },

            employeeTTIAffiliation() {
                return EmployeeTTIAffiliation;
            }
        },
        methods: {
            loadConstants() {
                const vm = this;
                vm.isLoading = true;

                PersonService.getPayIndicatorList()
                    .then(innerResponse => {
                        vm.payIndicators = innerResponse;
                        PersonService.getEmploymentStatuses()
                            .then(innerInnerResponse => {
                                vm.employmentStatuses = innerInnerResponse;
                                vm.filterOptions.employmentStatuses = innerInnerResponse.filter((status) => { return status.indicatesIsActive; }).map((status) => { return status.code; });
                                OrganizationService.getOrganizationList({
                                    returnAll: true,
                                    onlyShowActive: true,
                                    onlyShowWithPeople: true,
                                    sortByName: true
                                })
                                    .then((orgResponse) => {
                                        vm.organizations = orgResponse.data;
                                        PersonService.getExternalOrganizations()
                                            .then(externalOrgResponse => {
                                                vm.externalOrganizations = externalOrgResponse;
                                            })
                                            .catch(() => {
                                                vm.redirectToError();
                                            })
                                            .finally(() => {
                                                vm.loadData();
                                            })
                                    })
                                    .catch(() => {
                                        vm.redirectToError()
                                    })
                            })
                            .catch(() => {
                                vm.redirectToError()
                            })
                    })
                    .catch(() => {
                        vm.redirectToError()
                    })
            },

            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                PersonService.getPeopleList(vm.filterOptions)
                    .then(response => {
                        vm.people = response.data;
                        vm.totalPeople = response.totalCount;
                    })
                    .catch(() => {
                        vm.redirectToError()
                    })
                    .finally(() => {
                        vm.isLoading = false;
                    })
            },

            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },

            resetFilter() {
                this.incompleteRecordFlags = false;
                if (this.currentTabComponent === 'TheTTIPeopleList') {
                    this.filterOptions = {
                        page: 1,
                        pageSize: 10,
                        name: null,
                        uin: null,
                        organizationCode: null,
                        organizationId: null,
                        supervisorName: null,
                        onlyShowActive: false,
                        onlyShowMissingAddress: false,
                        onlyShowTTI: false,
                        isNonTTIEmployee: false,
                        employeeType: null,
                        employmentStatus: null,
                        employeeTypes: null,
                        employmentStatuses: this.employmentStatuses.filter((status) => { return status.indicatesIsActive; }).map((status) => { return status.code; }),
                        payIndicators: null,
                        adStatus: null,
                        employeeClassification: EmployeeClassification.TTI,
                        employeeTTIAffiliation: null,
                        incompleteRecordFlags: null,
                        externalOrganizationCode: null
                    };
                } else {
                    this.filterOptions = {
                        page: 1,
                        pageSize: 10,
                        name: null,
                        uin: null,
                        organizationCode: null,
                        organizationId: null,
                        supervisorName: null,
                        onlyShowActive: false,
                        onlyShowMissingAddress: false,
                        onlyShowTTI: false,
                        isNonTTIEmployee: true,
                        employeeType: null,
                        employmentStatus: null,
                        employeeTypes: null,
                        employmentStatuses: this.employmentStatuses.filter((status) => { return status.indicatesIsActive; }).map((status) => { return status.code; }),
                        payIndicators: null,
                        adStatus: null,
                        employeeClassification: null,
                        employeeTTIAffiliation: null,
                        incompleteRecordFlags: null,
                        externalOrganizationCode: null
                    };
                }
                this.onFilterSubmit();
            },

            /**
             * @description Downloads the people CSV export to the user's browse
             */
            downloadCsvExport() {
                this.isPerformingAction = true;
                const vm = this;

                PersonService.getNewExcelExport(this.filterOptions)
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    })
                    .finally(() => {
                        this.isPerformingAction = false
                    });
            },

            updateEmploymentStatuses() {
              this.filterOptions.employmentStatuses = [];
              if (this.showActiveEmploymentStatuses) {
                this.filterOptions.employmentStatuses.push(...this.activeEmploymentStatuses.map((status) => { return status.code; }));
              }
              if (this.showInactiveEmploymentStatuses) {
                this.filterOptions.employmentStatuses.push(...this.inactiveEmploymentStatuses.map((status) => { return status.code; }));
              }
              this.onFilterSubmit();
            },

            updateIncompleteRecordFlags() {
                if (this.currentTabComponent === "TheTTIPeopleList") {
                    if (this.incompleteRecordFlags) {
                        this.filterOptions.incompleteRecordFlags = IncompleteRecordFlag.UINFTEPayIndicatorOrganization;
                        return;
                    }
                } else {
                    if (this.incompleteRecordFlags) {
                        if ((this.filterOptions.employeeTTIAffiliation & EmployeeTTIAffiliation.ResearchAffiliate) === EmployeeTTIAffiliation.ResearchAffiliate) {
                            this.filterOptions.incompleteRecordFlags = IncompleteRecordFlag.UINEmailSupervisorOrganization;
                        } else {
                            this.filterOptions.incompleteRecordFlags = IncompleteRecordFlag.UINEmailSupervisor;
                        }
                        return;
                    }
                }
                this.filterOptions.incompleteRecordFlags = null;
            },

            updateNonTTIDesignation() {
                this.updateIncompleteRecordFlags();
                if ((this.filterOptions.employeeTTIAffiliation & EmployeeTTIAffiliation.ResearchAffiliate) !== EmployeeTTIAffiliation.ResearchAffiliate) {
                    this.filterOptions.onlyShowMissingAddress = false;
                    this.filterOptions.externalOrganizationCode = null;
                }
            }
        },
        created() {
            this.loadConstants();
            this.employeeTTIAffiliations = (Object.keys(EmployeeTTIAffiliationDescriptions).filter(x => x !== "PI/Co-PI on TTI Project" && isNaN(parseInt(x)))).map((key) => {
                const enumVal = EmployeeTTIAffiliationDescriptions[key]
                return {
                    value: enumVal,
                    item: key,
                    info: enumVal !== EmployeeTTIAffiliationDescriptions['Research Affiliate'] 
                            ? enumVal === EmployeeTTIAffiliationDescriptions['PI/Co-PI on Sponsored TTI Project'] 
                                ? "PI/Co-PI was or is on active or terminated TTI project within the past three fiscal years" 
                                : enumVal === EmployeeTTIAffiliationDescriptions['Paid on TTI Project']
                                    ? "Employee was or is on active or terminated TTI project within the past three fiscal years"
                                    : null
                            : null
                  }
              });

            this.adStatuses = (Object.keys(ADStatusDescriptions).filter(x => isNaN(parseInt(x)))).map((key) => {
                const enumVal = ADStatusDescriptions[key]
                return {
                    value: enumVal,
                    item: key
                  }
              });
        }
    }
</script>
